import React, { useState } from 'react'
import '../choose-purifier-service/choose-for-purifier.scss'
import NormalInput from '../../common/inputs/NormalInput'
import { useSearchParams } from 'react-router-dom'
import SelectInput from '../../common/inputs/SelectInput'


function FilterPromise({ setModal }) {
    const [searchParams, setSearchParams] = useSearchParams()

    const [form, setForm] = useState({
        from_date: searchParams.get('from_date') || '',
        end_date: searchParams.get('end_date') || '',
        bill_no: searchParams.get('bill_no') || '',
        party_id: searchParams.get('party_id') || '',
        status: searchParams.get('status') || '',
        date_type: searchParams.get('date_type') || ''
    })

    const handleChange = (e) => {
        setForm({
            ...form,
            [e.target.name]: e.target.value
        })
    }

    const handleSubmit = (e) => {
        e.preventDefault();

        setSearchParams((prev) => {
            const next = new URLSearchParams(prev);
            if (form?.from_date) {
                next.set('from_date', form?.from_date);
            } else {
                next.delete('from_date')
            }

            if (form?.end_date) {
                next.set('end_date', form?.end_date);
            } else {
                next.delete('end_date')
            }

            if (form?.bill_no) {
                next.set('bill_no', form?.bill_no);
            } else {
                next.delete('bill_no')
            }

            if (form?.party_id) {
                next.set('party_id', form?.party_id);
            } else {
                next.delete('party_id')
            }

            if (form?.status) {
                next.set('status', form?.status);
            } else {
                next.delete('status')
            }
            if (form?.date_type) {
                next.set('date_type', form?.date_type);
            } else {
                next.delete('date_type')
            }

            return next;
        })

        setModal({ status: false })
    }

    return (
        <div className='choose-for-purifier-div'>
            <form action="" onSubmit={handleSubmit}>

                <SelectInput label='Date Type' name='date_type' onChangeFun={handleChange} isRequired={false}
                    values={['creation', 'promised'].map((v) => ({ option: v, value: v, selected: v === searchParams.get('date_type') }))}
                    firstOption={{ option: 'Choose...', value: '' }} />
                <NormalInput label='From date' type={'date'} name='from_date' value={form?.from_date || ''} onChangeFun={handleChange}
                    min={'2022-10-11'} max={form?.end_date} isRequired={false} />
                <NormalInput label='End date' type={'date'} name='end_date' value={form?.end_date || ''} onChangeFun={handleChange}
                    min={form?.from_date} isRequired={false} />

                <NormalInput label='Bill No' name='bill_no' value={form?.bill_no || ''} onChangeFun={handleChange} isRequired={false}
                    placeholder={'Enter Bill No'} />
                <NormalInput label='Party Id / Customer Id' name='party_id' value={form?.party_id || ''} onChangeFun={handleChange} isRequired={false}
                    placeholder={'Enter Id'} />

                <SelectInput label='Promise Status' name='status' onChangeFun={handleChange} isRequired={false}
                    values={["ACTIVE", "FULFILLED", "PARTIAL", "CANCELLED"]
                        .map((v) => ({ option: v, value: v, selected: v === searchParams.get('status') }))}
                    firstOption={{ option: 'Choose...', value: '' }} />

                <div className="button-div">
                    <button type='submit'>Filter</button>
                </div>
            </form>
        </div>
    )
}

export default FilterPromise